<ng-container *ngIf="!isMobileViewport" [ngSwitch]="getComponentRenderState()">
  <ng-container *ngSwitchCase="'content'">
    <ng-container *ngFor="let loyaltyProgram of loyaltyPrograms">
      <rd-tcv2-loyalty-programs-list-item-desktop-wrapper
        class="loaded"
        [loyaltyProgram]="loyaltyProgram"
        [loyaltyCurrencySelected]="loyaltyCurrencySelected">
      </rd-tcv2-loyalty-programs-list-item-desktop-wrapper>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'loading'">
    <ng-container *ngFor="let number of [0, 1, 2, 3, 4, 5]">
      <rd-tcv2-loyalty-programs-list-item-desktop-wrapper
        class="loading"
        [loading]="true">
      </rd-tcv2-loyalty-programs-list-item-desktop-wrapper>
    </ng-container>
  </ng-container>

  <div class="containing-div" *ngSwitchCase="'error'">
    <rd-shared-error-sign></rd-shared-error-sign>
  </div>

  <div class="containing-div mt-20" *ngSwitchCase="'empty'">
    <ng-container *ngTemplateOutlet="emptyState"></ng-container>
  </div>
</ng-container>

<ng-container *ngIf="isMobileViewport" [ngSwitch]="getComponentRenderState()">
  <ng-container *ngSwitchCase="'content'">
    <ng-container *ngFor="let loyaltyProgram of loyaltyPrograms">
      <rd-tcv2-loyalty-programs-list-item-mobile-wrapper
        class="loaded mb-3 w-full"
        [loyaltyProgram]="loyaltyProgram"
        [loyaltyCurrencySelected]="loyaltyCurrencySelected">
      </rd-tcv2-loyalty-programs-list-item-mobile-wrapper>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'loading'">
    <ng-container *ngFor="let number of [0, 1, 2, 3, 4, 5]">
      <rd-tcv2-loyalty-programs-list-item-mobile-wrapper
        class="loading mb-3 w-full"
        [loading]="true">
      </rd-tcv2-loyalty-programs-list-item-mobile-wrapper>
    </ng-container>
  </ng-container>

  <div class="error-container" *ngSwitchCase="'error'">
    <rd-shared-error-sign></rd-shared-error-sign>
  </div>

  <div class="containing-div mx-6 mt-6 flex flex-col" *ngSwitchCase="'empty'">
    <ng-container *ngTemplateOutlet="emptyState"></ng-container>
  </div>
</ng-container>

<ng-template #emptyState>
  <img class="empty-state-icon" [src]="emptyLoyaltyProgramsImageUrl" />
  <h2 class="empty-loyalty-programs-title mt-6 mb-0">
    {{ 'transfer_v2.programs.no_loyalty_programs_found_title' | translate }}
  </h2>
  <p class="empty-loyalty-programs-text mt-2 mb-0">
    {{ 'transfer_v2.programs.no_loyalty_programs_found_text' | translate }}
  </p>
</ng-template>
